import React, { useEffect, useState } from 'react';
import { Modal, Form, Input, Select } from 'antd';
import { tagListRequest } from '@/service/tagManage';
import { TagCategoryEnum } from '@/constants/tagManage';

interface CoreSkillFormModalProps {
  visible: boolean;
  mode: 'add' | 'edit';
  initialValues?: any;
  onCancel: () => void;
  onOk: (values: any) => void;
  confirmLoading?: boolean;
}

/**
 * 核心技能表单弹窗组件
 */
const CoreSkillFormModal: React.FC<CoreSkillFormModalProps> = ({
  visible,
  mode,
  initialValues,
  onCancel,
  onOk,
  confirmLoading,
}) => {
  const [form] = Form.useForm();
  const [carTypeOptions, setCarTypeOptions] = useState<any[]>([]);

  // 获取车辆类型选项
  const getCarTypeOptions = async () => {
    try {
      const res = await tagListRequest({
        tagSorts: [TagCategoryEnum.carTypeData],
      });
      const tags = (res.data?.data || []).map((item: any) => {
        return { label: item.title, value: item.title };
      });
      setCarTypeOptions(tags);
    } catch (error) {
      console.error('获取车辆类型失败:', error);
      setCarTypeOptions([]);
    }
  };

  useEffect(() => {
    if (visible) {
      getCarTypeOptions();
      if (mode === 'edit' && initialValues) {
        form.setFieldsValue(initialValues);
      } else {
        form.resetFields();
      }
    }
  }, [visible, mode, initialValues, form]);

  const handleOk = () => {
    form.validateFields().then((values) => {
      onOk(values);
    });
  };

  return (
    <Modal
      title={mode === 'add' ? '新增核心技能' : '编辑核心技能'}
      visible={visible}
      onCancel={onCancel}
      onOk={handleOk}
      confirmLoading={confirmLoading}
      width={600}
      destroyOnClose
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="fuelTp"
          label="燃油类型"
          rules={[{ required: true, message: '请选择燃油类型' }]}
        >
          <Select placeholder="请选择燃油类型">
            <Select.Option value="汽油">汽油</Select.Option>
            <Select.Option value="柴油">柴油</Select.Option>
          </Select>
        </Form.Item>

        <Form.Item
          name="drivenVehModel"
          label="驾驶过的车型"
          rules={[{ required: true, message: '请选择驾驶过的车型' }]}
        >
          <Select placeholder="请选择驾驶过的车型" options={carTypeOptions} />
        </Form.Item>

        <Form.Item
          name="hasAuxEqptDriveExp"
          label="是否有辅助设备驾驶经验"
          rules={[{ required: true, message: '请选择是否有辅助设备驾驶经验' }]}
        >
          <Select placeholder="请选择">
            <Select.Option value="是">是</Select.Option>
            <Select.Option value="否">否</Select.Option>
          </Select>
        </Form.Item>

        <Form.Item
          name="trafficAccStat"
          label="交通事故出险情况"
          rules={[{ required: true, message: '请选择交通事故出险情况' }]}
        >
          <Select placeholder="请选择交通事故出险情况">
            <Select.Option value="无事故">无事故</Select.Option>
            <Select.Option value="有小型事故">有小型事故</Select.Option>
            <Select.Option value="有重大事故">有重大事故</Select.Option>
          </Select>
        </Form.Item>

        <Form.Item
          name="hasLongDistDriveExp"
          label="是否有长途驾驶经验"
          rules={[{ required: true, message: '请选择是否有长途驾驶经验' }]}
        >
          <Select placeholder="请选择">
            <Select.Option value="是">是</Select.Option>
            <Select.Option value="否">否</Select.Option>
          </Select>
        </Form.Item>

        <Form.Item
          name="hasLongTimeDriveExp"
          label="是否有长时间驾驶经验"
          rules={[{ required: true, message: '请选择是否有长时间驾驶经验' }]}
        >
          <Select placeholder="请选择">
            <Select.Option value="是">是</Select.Option>
            <Select.Option value="否">否</Select.Option>
          </Select>
        </Form.Item>

        <Form.Item
          name="hasNightWorkExp"
          label="是否有夜间工作经验"
          rules={[{ required: true, message: '请选择是否有夜间工作经验' }]}
        >
          <Select placeholder="请选择">
            <Select.Option value="是">是</Select.Option>
            <Select.Option value="否">否</Select.Option>
          </Select>
        </Form.Item>

        <Form.Item
          name="cargoTransQual"
          label="货物运输资质"
          rules={[{ required: true, message: '请选择货物运输资质' }]}
        >
          <Select placeholder="请选择货物运输资质">
            <Select.Option value="普通货物运输">普通货物运输</Select.Option>
            <Select.Option value="危险化学品运输">危险化学品运输</Select.Option>
          </Select>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CoreSkillFormModal;
